import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import React from "react";
import { FAQStyle } from "./style";
import { ButtonGroup } from "react-bootstrap";

export default function FAQ() {
    return (
    <FAQStyle id="faq">
      <div className="container">
        <div className="info">
          <h3>Perguntas Frequentes</h3>
          <p>Tire algumas dúvidas básicas aqui.</p>
        </div>
        
        <div style={{display: "flex", justifyContent: 'center', flexDirection: 'column'}}>
        <DropdownButton
              as={ButtonGroup}
              drop={"down-centered"}
              title={`Quais métodos de pagamentos?`}
              style={{
                border: "none",
                backgroundColor: "#dcdcdc",
                marginLeft: "-7px",
              }}
              variant="#dcdcdc"
            >
              <Dropdown.ItemText style={{ width: "335px", textAlign: 'center' }} eventKey="1">
                Pix <br/>
                <b>Cartões</b>: Débito ou Crédito <br/>
                <b>Bandeiras</b>: MasterCard e Visa <br/>
                <h5><b>Sem parcelamentos.</b></h5>
              </Dropdown.ItemText>
            </DropdownButton>

            <DropdownButton
              as={ButtonGroup}
              drop={"down-centered"}
              title={`Qual o preço dos serviços?`}
              style={{
                border: "none",
                backgroundColor: "#dcdcdc",
                marginLeft: "-7px",
              }}
              variant="#dcdcdc"
            >
              <Dropdown.ItemText style={{ width: "335px" }} eventKey="1">
                <ul id="#price">
                    <h4><b>Lavar e Passar</b></h4>
                    <li>Camisa - R$15,00 </li>
                    <li>Calça - R$15,00 </li>
                    <li>Terno - R$40,00 </li>
                    <li>Camisas (a partir de 5 unid) - R$12,00 </li>
                    <li>calças (a partir de 5 unid) - R$12,00 </li>
                    <li>Edredon - (a partir) R$35,00 </li>
                    <li>Cortina M² - R$10,00 </li>
                    <li>Tapete M² - R$30,00 </li>
                    <h4 style={{marginTop: '10px'}}><b>Passar</b></h4>
                    <li>Camisa - R$9,00 </li>
                    <li>Calça - R$9,00 </li>
                    <li>Calça ou Camisa (a partir de 5 unid) - R$8,00 </li>
                    <li>Calça ou camisa (a partir de 5 unid) - R$6,50 </li>
                </ul>
                <h2 style={{color: 'red', marginTop: '10px'}}>Valores para envio de seu próprio cabide</h2>
              </Dropdown.ItemText>
            </DropdownButton>

            <DropdownButton
              as={ButtonGroup}
              drop={"down-centered"}
              title={`A lavanderia entrega?`}
              style={{
                border: "none",
                backgroundColor: "#dcdcdc",
                marginLeft: "-7px",
              }}
              variant="#dcdcdc"
            >
              <Dropdown.ItemText style={{ width: "335px", textAlign: 'center' }} eventKey="1">
                Entregamos pela área da Zona Norte, Zona Sul. <br/>
                Zona Oeste ou demais localidades a consultar.
              </Dropdown.ItemText>
            </DropdownButton>

            <DropdownButton
              as={ButtonGroup}
              drop={"down-centered"}
              title={`Lavamos todos os tipos de roupa de cama?`}
              style={{
                border: "none",
                backgroundColor: "#dcdcdc",
                marginLeft: "-7px",
              }}
              variant="#dcdcdc"
            >
              <Dropdown.ItemText style={{ width: "335px", textAlign: 'center' }} eventKey="1">
                Possuímos maquinários para certos tipos de roupa de cama, para saber melhor se pudemos realizar esse serviço, entre em contato conosco <a href="https://wa.me/5521964534762">aqui</a>
              </Dropdown.ItemText>
            </DropdownButton>

            <DropdownButton
              as={ButtonGroup}
              drop={"down-centered"}
              title={`Qual o horário de funcionamento?`}
              style={{
                border: "none",
                backgroundColor: "#dcdcdc",
                marginLeft: "-7px",
              }}
              variant="#dcdcdc"
            >
              <Dropdown.ItemText style={{ width: "335px", textAlign: 'center'}} eventKey="1">
                    Funcionamos das 08:00 as 17:00, de segunda a sexta-feira.    
              </Dropdown.ItemText>
            </DropdownButton>
        </div>
      </div>
    </FAQStyle>
  );
}